var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed h-full w-full flex top-0 left-0 overlay z-10",class:{
    'justify-end': _vm.align === 'right',
    'justify-start': _vm.align === 'left',
    'pointer-events-none': !_vm.value,
    shadow: _vm.value,
  }},[_c('transition',{attrs:{"name":_vm.align === 'right' ? 'slide-left' : 'slide-right'}},[(_vm.value)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDrawer),expression:"closeDrawer"}],ref:"drawerContents"},[_c('FocusTrap',{attrs:{"active":_vm.value,"tabindex":"-1"}},[_vm._t("default")],2)],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }